import React from 'react'
import BuilderProReqOption from '../../Components/Bulider/BuilderProReqOption'


const BuilderReqCreatePage = () => {
  return (
    <div>
      <BuilderProReqOption />
    </div>
  )
}

export default BuilderReqCreatePage